export default "__VITE_ASSET__8a7d463e__"